import type { NextPage } from "next";
import type { SVGProps } from "react";

export interface FavouriteStateTrueIconProps extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FavouriteStateTrueIcon: NextPage<FavouriteStateTrueIconProps> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FavouriteStateTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.0913 5.1264C19.3323 4.5043 18.3952 4.09183 17.368 3.97667C17.1946 3.95294 16.8016 3.94346 16.7791 3.94346C15.0099 3.94346 13.4461 4.8223 12.5 6.16707C11.5538 4.82231 9.99007 3.94346 8.22087 3.94346C8.19826 3.94346 7.8042 3.953 7.63034 3.97684C6.60405 4.09222 5.66767 4.50443 4.9092 5.12594C3.82191 6.0169 3.00376 7.3343 3.00376 8.82834V11.8302C3.00376 12.9842 3.56674 14.0656 4.51214 14.7273L11.1815 19.6456C11.9729 20.1996 13.0263 20.1996 13.8178 19.6456L20.4875 14.7273C21.4329 14.0656 21.996 12.9842 21.996 11.8302V8.82357C21.996 7.33165 21.1771 6.0164 20.0913 5.1264Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.4963 20.5616C11.9332 20.5616 11.3722 20.3933 10.8928 20.0576L4.21281 15.1328C3.14427 14.3857 2.5 13.1483 2.5 11.8302V8.82791C2.5 7.31591 3.26191 5.8236 4.58982 4.73587C5.44623 4.035 6.47785 3.59892 7.57444 3.47587C7.75655 3.45127 8.19558 3.43945 8.22068 3.43945C9.86212 3.43945 11.4184 4.14623 12.4998 5.358C13.5816 4.14623 15.1379 3.43945 16.7793 3.43945C16.8039 3.43945 17.243 3.45127 17.4359 3.47785C18.5217 3.59893 19.5548 4.035 20.4107 4.73686C21.7386 5.82459 22.5 7.31493 22.5 8.82398V11.8302C22.5 13.1473 21.8557 14.3847 20.7764 15.1407L14.1171 20.0507C13.6298 20.3923 13.0623 20.5616 12.4963 20.5616ZM8.22068 4.44745C8.18722 4.44745 7.84958 4.45532 7.69847 4.476C6.78398 4.57936 5.93398 4.93767 5.22867 5.5155C4.13503 6.41127 3.50799 7.6191 3.50799 8.82791V11.8302C3.50799 12.8195 3.99131 13.7478 4.80096 14.3138L11.4809 19.2396C12.0863 19.6629 12.9137 19.6619 13.5289 19.2327L20.1882 14.3217C21.0087 13.7478 21.492 12.8186 21.492 11.8302V8.82398C21.492 7.61812 20.8649 6.41226 19.7718 5.51648C19.0665 4.93866 18.216 4.57936 17.3119 4.47797C17.1489 4.45533 16.8123 4.44746 16.7754 4.44746C15.2437 4.44746 13.7976 5.19854 12.9117 6.45755C12.8177 6.59142 12.6636 6.67115 12.4997 6.67115C12.3358 6.67115 12.1818 6.59142 12.0873 6.45755C11.2023 5.19854 9.7568 4.44745 8.22068 4.44745Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FavouriteStateTrueIcon;
